const state = {
  activebar: 'book',
  isshowbottom: true,
  beforerou: ''
}

const mutations = {
  SET_ACTIVEBAR(state, Active) {
    state.activebar = Active
  },
  SET_ISSHOWBOTTEM(state, IsShowBottom) {
    state.isshowbottom = IsShowBottom
  },
  SET_BEFOREROU(state, Rou) {
    state.beforerou = Rou
  }
}

const actions = {
  setActiveBar({ commit }, Active) {
    return new Promise(resolve => {
      commit('SET_ACTIVEBAR', Active)
      resolve()
    })
  },
  setIsShowBottom({ commit }, IsShow) {
    return new Promise(resolve => {
      commit('SET_ISSHOWBOTTEM', IsShow)
      resolve()
    })
  },
  setBeforeRou({ commit }, Rou) {
    return new Promise(resolve => {
      commit('SET_BEFOREROU', Rou)
      resolve()
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js